import * as THREE from 'three'
import { useFrame } from '@react-three/fiber'

const cursor = { x: 0, y: 0 }
window.addEventListener('pointermove', (e) => {
  cursor.x = e.clientX / window.innerWidth - 0.5
  cursor.y = e.clientY / window.innerHeight - 0.5
})

export default function CameraParallax() {
  useFrame((state, delta) => {
    state.camera.position.x += (-cursor.x * 1.6 - state.camera.position.x) * 8 * delta
    state.camera.position.y += (cursor.y * 0.3 - state.camera.position.y) * 8 * delta
    state.camera.lookAt(new THREE.Vector3(0, 0, 0))
  })

  return <></>
}
